import AssetDetailView from './AssetDetailView';
import AssetListView from './AssetListView';

const views = {
  AssetDetailView,
  AssetListView,
};
export default views;
